import { Drawer as NovaBaseDrawer } from '@fme-nova/components'
import { Drawer as MuiBaseDrawer, DrawerProps } from '@mui/material'

import { styled } from '../../theme'
import { createComponentWrapperWithRef, Z_INDEX } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

const MuiDrawer: MsdkStyledComponent<DrawerProps> = styled(MuiBaseDrawer)`
  z-index: ${Z_INDEX.sticky};
`

const NovaDrawer: MsdkStyledComponent<DrawerProps> = styled(NovaBaseDrawer)`
  z-index: ${Z_INDEX.sticky};
`

export const Drawer = createComponentWrapperWithRef<DrawerProps>(
  {
    mui: MuiDrawer,
    nova: NovaDrawer,
  },
  'Drawer',
)
